<template>
  <!-- 权益 -->
  <ul class="home-rights-wrapper">
    <!-- <li class="list" v-for="(item, index) in rightsList" :key="index">
      <div class="left">
        <div class="icon" :class="`icon${index}`"></div>
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
        <div class="joinbtn" @click="gotoJoin">{{index === 2 ? '立即领取':'立即参与'}}</div>
      </div>
      <div class="right" :class="`img${index}`"></div>
    </li>
    <li class="rightsmore">更多权益...</li> -->
    <!-- <van-popup v-model="courseShow" round class="course-van-popup">
      <div class="wanliu-wrapper">
        <div class="close" @click="courseShow = false"></div>
        <div class="icon"></div>
        <div class="title">领课后<br>即可解锁该权益哦~</div>
        <div class="btn-group">
          <div @click="sureHandler" class="rightbtn">立即领课</div>
        </div>
      </div>
  </van-popup> -->
  </ul>

</template>
<script>
import { SOURCEID, GETCOURSE } from '../const'
export default {
  data() {
    return {
      courseShow: false
    }
  },
  props: {
    rightsList: {
      type: Array
    },
    isLogin: {
      type: Boolean
    }

  },
  methods: {
    gotoJoin() {
      if (this.isLogin) {
        this.courseShow = true
      } else {
        this.$emit('gotoLogin')
      }
    },
    sureHandler() {
      this.courseShow = false
      if (this.isLogin) {
        // 领取课程  渠道号
        const { channelId = '' } = this.$route.query || {}
        window.location.href = `${GETCOURSE}&sourceId=${SOURCEID}&channelId=${channelId}`
      } else {
        this.$emit('gotoLogin')
      }
    }

  }
}
</script>

<style lang="less" scoped>
.home-rights-wrapper {
  height: 725px/2;
  padding-top: 86px/2;
  margin: 0 8px/2;
  background: url(../assets/images/gift.png) no-repeat;
  background-size: cover;

  // .list {
  //   display: flex;
  //   padding: 0 45px;
  //   padding-top: 30px;

  //   .right {
  //     width: 150px/2;
  //     height: 150px/2;
  //     background: transparent;
  //     background-size: cover;
  //     background-repeat: no-repeat;
  //     border-radius: 5px;
  //   }

  //   .img0 {
  //     background-image: url(../assets/images/img0.png);
  //   }

  //   .img1 {
  //     background-image: url(../assets/images/img1.png);
  //   }

  //   .img2 {
  //     background-image: url(../assets/images/img2.png);
  //   }

  //   .left {
  //     flex: 1;

  //     .icon {
  //       width: 97px/2;
  //       height: 40px/2;
  //       background-size: 100% auto;
  //       background-repeat: no-repeat;
  //     }

  //     .icon0 {
  //       background-image: url(../assets/images/rights0.png);
  //     }

  //     .icon1 {
  //       background-image: url(../assets/images/rights1.png);
  //     }

  //     .icon2 {
  //       background-image: url(../assets/images/rights2.png);
  //     }

  //     .title {
  //       margin-top: 19/2px;
  //       overflow: hidden;
  //       font-size: 15px;
  //       font-weight: bold;
  //       line-height: 16px;
  //       white-space: nowrap;
  //       color: #a6662e;
  //       text-overflow: ellipsis;
  //     }

  //     .desc {
  //       margin-top: 13px/2;
  //       font-size: 12px;
  //       line-height: 13px;
  //       color: #d29c6d;
  //     }

  //     .joinbtn {
  //       position: absolute;
  //       font-size: 22px/2;
  //       font-weight: 400;
  //       font-family: FZLanTingHeiS-DB1-GBK;
  //       line-height: 28px;
  //       color: #e9343c;
  //       text-decoration: underline;
  //     }
  //   }
  // }

  // .rightsmore {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   margin-top: 22px/2;
  //   // text-align: center;
  //   font-size: 12px;
  //   color: #acacac;

  //   &::before {
  //     display: inline-block;
  //     width: 22px/2;
  //     height: 27px/2;
  //     margin-right: 10px/2;
  //     background: url(../assets/images/lock.png) no-repeat;
  //     background-size: cover;
  //     content: '';
  //   }
  // }

  // .course-van-popup {
  //   overflow-y: unset !important;

  //   .wanliu-wrapper {
  //     display: flex;
  //     flex-direction: column;
  //     justify-content: center;
  //     align-items: center;
  //     width: 590px/2;
  //     height: 412px/2;
  //     padding: 40px/2 40px/2;
  //     text-align: center;
  //     background: #fff;
  //     border-radius: 10px;
  //   }

  //   .icon {
  //     width: 33px;
  //     height: 33px;
  //     background: url(../assets/images/wanliu.png) no-repeat;
  //     background-size: cover;
  //   }

  //   .title {
  //     margin-top: 12px;
  //     font-size: 16px;
  //     font-weight: bold;
  //     color: #90402c;
  //   }

  //   .desc {
  //     margin-top: 16px;
  //     font-size: 12px;
  //     color: #666;
  //   }

  //   .btn-group {
  //     display: flex;
  //     justify-content: center;
  //     width: 100%;
  //     height: 70px/2;
  //     margin-top: 44px/2;

  //     div {
  //       width: 231px;
  //       height: 35px;
  //       font-size: 30px/2;
  //       font-weight: 400;
  //       line-height: 35px;
  //       text-align: center;
  //       color: #fff;
  //       background: linear-gradient(-69deg, #e42225 0%, #ed4351 99%);
  //       border-radius: 35px/2;
  //     }
  //   }
  // }
}
</style>
